





























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";

@Component
export default class TransactionsCriteriaPicker extends Vue {

  @Prop()
  baseCriterias?: FilterCriteria[]

  criterias: FilterCriteria[] = []

  @Prop()
  criteriaOptions!: CriteriaType[]

  value = ''
  selectedCriteria: CriteriaType = CriteriaType.MSISDN

  mounted() {
    if(this.baseCriterias) {
      this.criterias.push(...this.baseCriterias);
    }
    this.selectedCriteria = this.criteriaOptions[0];
  }

  @Watch('criterias',{
    'deep': true
  })
  onCriteriasUpdated() {
    this.$emit('criteriaUpdated',this.criterias)
  }

  addCriteria() {
    this.criterias.push(new FilterCriteria(this.selectedCriteria,this.value))
  }
}
